module.exports = __webpack_public_path__ + "img/DataExplorer-dark.e279d6d0.svg";